"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChoiceLabel = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
var styled_1 = __importDefault(require("@emotion/styled"));
var RegistrationLimitStatusLabel_1 = require("./RegistrationLimitStatusLabel");
var Wrapper = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var ChoiceNumber = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 16px;\n  line-height: 1.5;\n  margin-right: 8px;\n  white-space: nowrap;\n"], ["\n  color: ", ";\n  font-size: 16px;\n  line-height: 1.5;\n  margin-right: 8px;\n  white-space: nowrap;\n"])), function (_a) {
    var color = _a.color;
    return color;
});
var Label = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 16px;\n  line-height: 1.5;\n"], ["\n  color: ", ";\n  font-size: 16px;\n  line-height: 1.5;\n"])), function (_a) {
    var color = _a.color;
    return color;
});
var ChoiceLabel = function (_a) {
    var label = _a.label, choiceNumber = _a.choiceNumber, color = _a.color, remain = _a.remain, deadlineExceeded = _a.deadlineExceeded, _b = _a.optionIsDisabled, optionIsDisabled = _b === void 0 ? false : _b, _c = _a.hideRemain, hideRemain = _c === void 0 ? true : _c;
    var opacity = optionIsDisabled ? 0.5 : 1;
    if (!choiceNumber) {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Label, __assign({ color: color, style: { opacity: opacity } }, { children: label })), remain != null && ((0, jsx_runtime_1.jsx)(RegistrationLimitStatusLabel_1.RegistrationLimitStatusLabel, { value: remain, color: color, deadlineExceeded: !!deadlineExceeded, css: { opacity: opacity }, hideRemain: hideRemain }))] }));
    }
    return ((0, jsx_runtime_1.jsxs)(Wrapper, __assign({ style: { opacity: opacity } }, { children: [(0, jsx_runtime_1.jsxs)(ChoiceNumber, __assign({ color: color }, { children: [choiceNumber, "."] })), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(Label, __assign({ color: color }, { children: label })), remain != null && ((0, jsx_runtime_1.jsx)(RegistrationLimitStatusLabel_1.RegistrationLimitStatusLabel, { value: remain, color: color, deadlineExceeded: !!deadlineExceeded, hideRemain: hideRemain }))] })] })));
};
exports.ChoiceLabel = ChoiceLabel;
var templateObject_1, templateObject_2, templateObject_3;
